import { auth } from '../firebase';

/**
 * Emails the team invite for a userInvites doc. The function builds the
 * recipient and signup link from the stored invite and only accepts
 * Owners/Executives, so the caller's ID token goes in the Authorization header.
 */
export const sendInviteEmail = async ({ inviteId }) => {
  try {
    const functionUrl = 'https://us-central1-bba-portal-894c2.cloudfunctions.net/sendInviteEmail';
    const idToken = await auth.currentUser?.getIdToken();

    const response = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
      },
      mode: 'cors',
      credentials: 'omit',
      body: JSON.stringify({ inviteId }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || errorData.message || `HTTP ${response.status}: Failed to send email`);
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message || 'Failed to send email');
    }

    return result.data;
  } catch (error) {
    console.error('Error sending invite email:', error);

    // If it's a CORS error, provide a helpful message
    if (error.message.includes('CORS') || error.message.includes('Failed to fetch')) {
      throw new Error('Email service is temporarily unavailable. Please try again later or contact support.');
    }

    throw error;
  }
};
